import { withProps } from 'recompose';
import wizard from './wizardData';
import FormStep from '../../FormStep';

const Form = withProps({ wizard })(FormStep);

export default Form;
